<template>
  <div
    class="absolute inset-0 overflow-hidden pointer-events-none"
    aria-hidden="true"
  >
    <div class="stars-layer stars-a" />
    <div class="stars-layer stars-b" />
    <div class="stars-layer stars-c" />
  </div>
</template>

<style scoped>
.stars-layer {
  position: absolute;
  inset: 0;
  height: 200%;
  background-repeat: repeat;
}

/* Each layer tiles a handful of radial-gradient "stars" and scrolls up by
   exactly one tile height for a seamless loop — 3 DOM nodes total. */
.stars-a {
  background-image:
    radial-gradient(1px 1px at 25px 35px, rgba(255, 255, 255, 0.7) 50%, transparent 51%),
    radial-gradient(1px 1px at 130px 90px, rgba(255, 255, 255, 0.5) 50%, transparent 51%),
    radial-gradient(1px 1px at 80px 160px, rgba(255, 255, 255, 0.6) 50%, transparent 51%),
    radial-gradient(1px 1px at 190px 40px, rgba(255, 255, 255, 0.4) 50%, transparent 51%);
  background-size: 220px 220px;
  animation: stars-rise 70s linear infinite;
}

.stars-b {
  background-image:
    radial-gradient(1.5px 1.5px at 60px 60px, rgba(255, 255, 255, 0.55) 50%, transparent 51%),
    radial-gradient(1.5px 1.5px at 200px 140px, rgba(255, 255, 255, 0.4) 50%, transparent 51%),
    radial-gradient(1px 1px at 150px 230px, rgba(255, 255, 255, 0.5) 50%, transparent 51%);
  background-size: 260px 260px;
  animation: stars-rise-b 50s linear infinite;
}

.stars-c {
  background-image:
    radial-gradient(2px 2px at 100px 100px, rgba(255, 255, 255, 0.45) 50%, transparent 51%),
    radial-gradient(1.5px 1.5px at 240px 200px, rgba(255, 255, 255, 0.35) 50%, transparent 51%);
  background-size: 300px 300px;
  animation: stars-rise-c 36s linear infinite;
}

@keyframes stars-rise {
  to { transform: translateY(-220px); }
}

@keyframes stars-rise-b {
  to { transform: translateY(-260px); }
}

@keyframes stars-rise-c {
  to { transform: translateY(-300px); }
}
</style>
